import { useMemo } from 'react';
import { DocumentationFile } from '../../../graphql/graphql';
import useTranslation from '../../../Hooks/useTranslation';

export default function useDocumentationFile(
	documentationFile: DocumentationFile,
) {
	const { t } = useTranslation();

	const pages: string | undefined = useMemo(() => {
		const groupedFilesCount: number | undefined | null =
			documentationFile.groupFilesCount;
		if (groupedFilesCount && groupedFilesCount > 1) {
			switch (groupedFilesCount) {
				case 2:
				case 3:
				case 4:
					return `(${groupedFilesCount} ${t(
						'component.eCardNewFilesListItem.pages.two',
					)})`;
				default:
					return `(${groupedFilesCount} ${t(
						'component.eCardNewFilesListItem.pages.many',
					)})`;
			}
		}
		return undefined;
	}, [documentationFile]);

	return { pages };
}
